import { Button, Chip, Container, Paper, Stack } from "@mui/material";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { BodyText } from "../../../widgets/TemplatePreview";
const ShowTextMessage = ({ data, onOpen, preview = false }) => {
  return (
    <Container maxWidth="md">
      <Paper sx={{ p: 2, maxWidth: "sm" }} variant="outlined" elevation={0}>
        {!preview && (
          <Stack my={1} direction={"row"} spacing={1} flexWrap={"wrap"}>
            {data.triggerText.map((item) => (
              <Chip variant="outlined" label={item} clickable />
            ))}
          </Stack>
        )}
        <BodyText>{data.text}</BodyText>
        {!preview && (
          <Stack direction={"row"} justifyContent={"end"}>
            <Button
              onClick={() => {
                onOpen?.();
              }}
              startIcon={<AddIcon />}
              variant="outlined"
              size="small"
            >
              Add trigger
            </Button>
          </Stack>
        )}
      </Paper>
    </Container>
  );
};

export default ShowTextMessage;
